import { render, staticRenderFns } from "./product-questions-modal.vue?vue&type=template&id=2ec03d3c&"
import script from "./product-questions-modal.vue?vue&type=script&lang=js&"
export * from "./product-questions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports